import React from 'react';

export default function PinIcon({ color = '#008080', number = 1, size = 24 }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: 20,
      height: 28,
      position: 'relative',
    }}>
      {/* Pin head - simple circle with number */}
      <div style={{
        width: 16,
        height: 16,
        borderRadius: '50%',
        background: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 600,
        fontSize: 10,
        position: 'relative',
        zIndex: 2,
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        marginTop: "6px"
      }}>
        {number}
      </div>
      
      {/* Pin shaft */}
      <div style={{
        width: 2,
        height: 8,
        background: color,
        marginTop: -1,
        zIndex: 1,
      }} />
      
      {/* Pin tip */}
      <div style={{
        width: 0,
        height: 0,
        borderLeft: '1px solid transparent',
        borderRight: '1px solid transparent',
        borderTop: '3px solid',
        borderTopColor: color,
        marginTop: -1,
        zIndex: 1,
      }} />
    </div>
  );
} 